
export const CONSTANT_CONFIG_ID = 1;
export const CONSTANT_CONFIG_FEDERAL_ID = 2;

export const EXISTING_FIELDS = 'estimateExisting';
export const NEW_FIELDS = 'estimateNew';

export const ROI_INFORMATION: any = {[NEW_FIELDS]:  'Savings with Proposed Tools', [EXISTING_FIELDS]: 'Savings with Existing Tools'};
export const COVERAGE_INFORMATION: any = {[NEW_FIELDS]:  'Coverage of Proposed Riverbed Platform', [EXISTING_FIELDS]: 'Coverage of Existing Tools'};

export const isRoleIncluded = (roleId: number, allowedRoles: number[]) => {
  return allowedRoles?.includes(roleId);
};